import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AssetListLayer from "../components/AssetListLayer";
import { Icon } from "@iconify/react";
import { useSetting } from '../utils/AppSettingsContext';

const AssetListPage = () => {
  const normaliseViewMode = useCallback((mode) => {
    if (typeof mode !== 'string') {
      return 'table';
    }

    const trimmed = mode.trim().toLowerCase();
    return ['panel', 'table', 'cards', 'map'].includes(trimmed) ? trimmed : 'table';
  }, []);

  const defaultAssetView = useSetting('default_asset_view');
  const [viewMode, setViewMode] = useState(() => normaliseViewMode(defaultAssetView));
  const hasUserSelectedViewMode = useRef(false);

  useEffect(() => {
    if (hasUserSelectedViewMode.current) return;

    setViewMode(normaliseViewMode(defaultAssetView));
  }, [defaultAssetView, normaliseViewMode]);

  const handleSetViewMode = useCallback((mode) => {
    hasUserSelectedViewMode.current = true;
    setViewMode(mode);
  }, []);

  const headerActions = useMemo(() =>(
    <div className="btn-group" role="group">
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'table' ? 'bg-white text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => handleSetViewMode('table')}
      >
        <Icon icon="ic:baseline-table-view" className="icon text-xl line-height-1" /> Table
      </button>
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'cards' ? 'bg-white-300 text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => handleSetViewMode('cards')}
      >
        <Icon icon="mage:credit-card" className="icon text-xl line-height-1" /> Cards
      </button>
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'map' ? 'bg-white text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => handleSetViewMode('map')}
      >
        <Icon icon="mdi:map" className="icon text-xl line-height-1" /> Map
      </button>
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'panel' ? 'bg-white text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => handleSetViewMode('panel')}
      >
        <Icon icon="mdi:view-split-vertical" className="icon text-xl line-height-1" /> Panel
      </button>
    </div>
  ), [viewMode]);

  return (
    <>

      {/* MasterLayout */}
      <MasterLayout pageTitle="Assets" headerActions={headerActions}>

        {/* AssetListLayer */}
        <AssetListLayer viewMode={viewMode} />

      </MasterLayout>

    </>
  );
};

export default AssetListPage; 
